import { Graphics as PixiGraphics } from "@pixi/graphics";
import { Container, Graphics } from "@pixi/react";
import { VISUALIZATION_LAYOUT } from "./constants";

interface BallProps {
  ballPosition: any;
}

const drawBall = (g: PixiGraphics) => {
  g.clear();
  g.beginFill(0xffffff);
  g.drawCircle(0, 0, 6);
  g.endFill();
};

const Ball = ({ ballPosition }: BallProps) => {
  if (!ballPosition) return null;

  return (
    <Container x={VISUALIZATION_LAYOUT.playerLayerOrigin.x + ballPosition.x} y={VISUALIZATION_LAYOUT.playerLayerOrigin.y + ballPosition.y}>
      <Graphics draw={drawBall} />
    </Container>
  );
};

export default Ball;
